// i18next-extract-mark-ns-start header

import React, { FC, useMemo } from 'react'
import { useLocation } from '@reach/router'
import { isInitialLoad } from 'src/helpers/animations'
import { IHeaderProps } from './header/types'
import { MobileHeader } from './header/MobileHeader'
import { DesktopHeader } from './header/DesktopHeader'
import { useHeaderScroll } from './header/useHeaderScroll'
import { useHeaderMenuItems } from './header/useHeaderMenuItems'

export type { IHeaderProps }

const Header: FC<IHeaderProps> = ({
  showSearch = false,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  searchSlot,
  actionText,
  actionUrl,
  onActionClick,
  actionSlot,
  actionIcon,
  isActionOutline = false,
  disableAnimation = false,
  showIso = true,
  showAnniversaryTicker = true,
  isHome: propIsHome,
}): JSX.Element => {
  const location = useLocation()
  const isDesignSystem = location.pathname?.includes('/design-system')
  const isSlides = location.pathname?.includes('/slides')
  const shouldShowIso = showIso && !isSlides
  const browserPath = typeof window !== 'undefined' ? window.location.pathname : ''
  const currentPathname = browserPath || location?.pathname || ''
  const rawPath = currentPathname.replace(/^\/(?:pl|en)(?=\/|$)/, '') || '/'
  const cleanPath = rawPath.replace(/\/$/, '') || '/'
  const isHome = propIsHome ?? (cleanPath === '/')

  const { isMenuOpen, setIsMenuOpen, isCollapsed } = useHeaderScroll()
  const menuItems = useHeaderMenuItems(shouldShowIso)

  // Determine if we should perform the entrance animation (only on initial site load)
  const shouldAnimate = useMemo(() => !disableAnimation && isInitialLoad(), [disableAnimation])

  return (
    <>
      <MobileHeader
        menuItems={menuItems}
        showAnniversaryTicker={showAnniversaryTicker}
        showSearch={showSearch}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        searchPlaceholder={searchPlaceholder}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        isCollapsed={isCollapsed}
        isHome={isHome}
      />

      <DesktopHeader
        showAnniversaryTicker={showAnniversaryTicker}
        showSearch={showSearch}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        searchPlaceholder={searchPlaceholder}
        searchSlot={searchSlot}
        shouldAnimate={shouldAnimate}
        shouldShowIso={shouldShowIso}
        isDesignSystem={isDesignSystem}
        actionText={actionText}
        actionUrl={actionUrl}
        onActionClick={onActionClick}
        actionSlot={actionSlot}
        actionIcon={actionIcon}
        isActionOutline={isActionOutline}
      />
    </>
  )
}

export default Header
